import {Injectable} from '@angular/core';
import {McticHttpClient} from '@mctic/ng-core';
import {PessoaFisica} from '../shared/model';

@Injectable({
  providedIn: 'root'
})
export class PessoaFisicaService {

  private readonly service = '/sepin-backend/rest/proxy/pessoa-fisica';

  constructor(private readonly http: McticHttpClient) {
  }

  consultarPorCpf(cpf: string) {
    return this.http.get<PessoaFisica>(`${this.service}/cpf/${cpf}`);
  }

  consultarPorId(id) {
    return this.http.get<PessoaFisica>(`${this.service}/basico-momento/${id}`);
  }

}
